import { useTranslation } from 'react-i18next'

import { SwitchFormField } from '@/components/form'
import { FieldRow, FieldValue } from '@/components/layout/field-row'
import { SelectOption } from '@/components/ui/select'
import { Building } from '@/reducers/types'

import { PlaceFeatureRow } from '../../flags/place-feature-row'
import { GeneralControl } from './general-control'
import {
  getPlaceGeneralRowLabelKey,
  PLACE_GENERAL_FLAG_ROWS,
  PLACE_GENERAL_PHOTO_ROWS,
  PLACE_GENERAL_REQUIRED_ROWS,
  PLACE_GENERAL_SWITCH_ROWS,
  PlaceGeneralFlagKey,
  PlaceGeneralRowId,
} from './general-tab.constants'

interface GeneralEditRowProps {
  building: Building
  countryLabel: string
  isAdmin: boolean
  row: PlaceGeneralRowId
  tagOptions: SelectOption<string>[]
  timezoneOptions: SelectOption<string>[]
}

export const GeneralEditRow = ({
  building,
  countryLabel,
  isAdmin,
  row,
  tagOptions,
  timezoneOptions,
}: GeneralEditRowProps) => {
  const { t } = useTranslation(['organisation'])

  const label = t(getPlaceGeneralRowLabelKey(row))

  if (PLACE_GENERAL_FLAG_ROWS.includes(row)) {
    return (
      <PlaceFeatureRow
        isEditing
        building={building}
        featureKey={row as PlaceGeneralFlagKey}
        isAdmin={isAdmin}
        layout="field"
      />
    )
  }

  if (PLACE_GENERAL_SWITCH_ROWS.includes(row)) {
    return (
      <FieldRow label={label}>
        <FieldValue>
          <SwitchFormField name={row} size="small" />
        </FieldValue>
      </FieldRow>
    )
  }

  let hint: string | undefined
  if (row === 'timezone' && building.timezone) {
    hint = t('organisation:places.general.timezoneLocked')
  } else if (row === 'residentConvenienceFeeRate') {
    hint = t('organisation:places.building.fields.residentConvenienceFeeRate.hint')
  }

  return (
    <FieldRow
      hint={hint}
      label={label}
      photo={PLACE_GENERAL_PHOTO_ROWS.includes(row)}
      required={PLACE_GENERAL_REQUIRED_ROWS.includes(row)}
    >
      <GeneralControl
        building={building}
        countryLabel={countryLabel}
        row={row}
        tagOptions={tagOptions}
        timezoneOptions={timezoneOptions}
      />
    </FieldRow>
  )
}
